export const EMAIL_TEMPLATES = [
  {
    id: "lead-follow-up",
    label: "Lead follow-up",
    subject: "Following up on your enquiry",
    bodyHtml: (ctx: EmailTemplateContext) => `<p>Hi ${name(ctx)},</p>
<p>Thanks for getting in touch. I wanted to follow up while the detail is fresh and understand what would make this useful for ${company(ctx)}.</p>
<p>Would you be open to a short call this week to confirm the outcome, timing, and next step?</p>
<p>Best,<br>${sender(ctx)}</p>`,
  },
  {
    id: "proposal-follow-up",
    label: "Proposal follow-up",
    subject: "Next step on the proposal",
    bodyHtml: (ctx: EmailTemplateContext) => `<p>Hi ${name(ctx)},</p>
<p>I wanted to check whether the proposal answered the main points for ${company(ctx)}.</p>
<p>If it helps, I can also send a shorter decision summary covering scope, price, timing, and the first project milestone.</p>
<p>Best,<br>${sender(ctx)}</p>`,
  },
  {
    id: "signature-reminder",
    label: "Signature reminder",
    subject: "Signature still open",
    bodyHtml: (ctx: EmailTemplateContext) => `<p>Hi ${name(ctx)},</p>
<p>A quick nudge that the document is still open for signature. Once it is signed, we can move straight into kickoff and confirm the first delivery checkpoint.</p>
<p>Best,<br>${sender(ctx)}</p>`,
  },
  {
    id: "project-kickoff",
    label: "Project kickoff",
    subject: "Kickoff and first actions",
    bodyHtml: (ctx: EmailTemplateContext) => `<p>Hi ${name(ctx)},</p>
<p>Great to be underway. The first step is to confirm the project goals, owners, and any source material we should use.</p>
<p>I will send the initial project view shortly so everyone can see the current status and next actions.</p>
<p>Best,<br>${sender(ctx)}</p>`,
  },
] as const;

export type EmailTemplateId = (typeof EMAIL_TEMPLATES)[number]["id"];

interface EmailTemplateContext {
  firstName?: string | null;
  companyName?: string | null;
  senderName?: string | null;
}

export function getEmailTemplate(id?: string | null) {
  return EMAIL_TEMPLATES.find((template) => template.id === id) ?? null;
}

export function renderEmailTemplate(id: EmailTemplateId, context: EmailTemplateContext = {}) {
  const template = getEmailTemplate(id);
  if (!template) throw new Error(`Unknown email template: ${id}`);
  return {
    subject: template.subject,
    bodyHtml: template.bodyHtml(context),
  };
}

function name(ctx: EmailTemplateContext) {
  return escapeHtml(ctx.firstName?.trim() || "there");
}

function company(ctx: EmailTemplateContext) {
  return escapeHtml(ctx.companyName?.trim() || "your business");
}

function sender(ctx: EmailTemplateContext) {
  return escapeHtml(ctx.senderName?.trim() || "the team");
}

function escapeHtml(value: string) {
  return value
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#39;");
}
